import React, { useEffect } from 'react'
import {
  Grid, Paper, Typography, makeStyles,
  createStyles, Theme
} from '@material-ui/core'
import QABasicEditForm from './qabasicedit/QABasicEditForm'
import * as wijmo from "@grapecity/wijmo";
import { getAttachedFile, putQaContent, typeputForm, typeQaContent, typeQaEnvironment, typeUserInfoList } from '../../../../api/helpline/qa'
import { getUserInfo, typeUserInfo } from '../../../../api/helpline/user'
import { getCategory, getMemberList, typeCategory, typeMemberList } from '../../../../api/helpline/master'
import { useGlobalState } from '../../../../provider/Provider'
import { getCisUserList, getContractItemList, typeCisUserList, typeContractItemList } from '../../../../api/helpline/keiyaku'
import { lookup } from 'mime-types'
import * as importpath from 'path'
import FormAreaBasicEdit from './qabasicedit/FormAreaBasicEdit';
import { isValid, parseISO } from 'date-fns';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
)

interface Prop {
  qaContent: typeQaContent | undefined,
  qaEnv: typeQaEnvironment | undefined,
  userInfo: typeUserInfo | undefined,
  userInfoList: typeUserInfoList | undefined,
  handleError: (err: any) => void,
  handleNotificationOpen: (level: "success" | "info" | "warning" | "error", message: string) => void,
  handleCloseBasicEdit: () => void,
  handleAddSubmitCount: () => void,
  qabasicEdit: boolean,
}


const QABasicEdit: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const globalState = useGlobalState('user')
  const { userId, token, role } = globalState
  const { qaContent, qaEnv, userInfo, userInfoList, handleError, handleNotificationOpen, handleCloseBasicEdit, handleAddSubmitCount, qabasicEdit } = props

  const dateFormat = (datevalue: string): Date | null => {
    try {
      const date = parseISO(datevalue)
      if (isValid(date)) {
        return date
      } else {
        return null
      }
    } catch {
      return null
    }
  }

  const [loading, setLoading] = React.useState<boolean>(false)
  const [keiyakuClsCd, setKeiyakuClsCd] = React.useState<string>(qaContent ? qaContent.keiyakuClsCd : '')
  const [memberList, setMemberList] = React.useState<typeMemberList[]>([])
  const [answerDate, setAnswerDate] = React.useState<Date | null>(qaContent?.answerDate ? dateFormat(qaContent?.answerDate) : null)
  const [reqItem, setReqItem] = React.useState({
    qPersonCd: true,
    qaTitle: true,
    qaSeCd: true,
    custmNo: true,
    keiyakuNo: true,
  })
  const [loginUser, setLoginUser] = React.useState(false)
  //CIS社員情報
  const [cisUserList, setCisUserList] = React.useState<typeCisUserList[]>([])
  const [fileloading, setFileloading] = React.useState<boolean>(false)
  //契約項目
  const [contractItemList, setContractItemList] = React.useState<typeContractItemList[]>([])
  const [selectKeiyaku, setSelectKeiyaku] = React.useState<typeContractItemList | undefined>()
  ////カテゴリー取得
  //問合わせ方法
  const [questionway, setQuestionway] = React.useState<typeCategory[]>([])
  //QA対応状況
  const [qastatus, setQastatus] = React.useState<typeCategory[]>([])
  //SuperStreamバージョン
  const [ss_version, setSs_version] = React.useState<typeCategory[]>([])
  //サーバー環境（OS）
  const [ss_serverOS, setSs_serverOS] = React.useState<typeCategory[]>([])
  //サーバー環境（DB）
  const [ss_serverDB, setSs_serverDB] = React.useState<typeCategory[]>([])
  //サーバー環境（接続）
  const [ss_serverConnect, setSs_serverConnect] = React.useState<typeCategory[]>([])
  //アプリケーションサーバー
  const [ss_applicationserver, setSs_applicationserver] = React.useState<typeCategory[]>([])
  //クライアント環境（OS）
  const [ss_clientOS, setSs_clientOS] = React.useState<typeCategory[]>([])
  //クライアント環境（DB）
  const [ss_clientDB, setSs_clientDB] = React.useState<typeCategory[]>([])
  const [newfile, setNewfile] = React.useState({
    attachedFile: '',
    attachedFileData: ''
  })
  const [basicForm, setBasicForm] = React.useState<typeputForm>({
    qaNo: qaContent?.qaNo,
    qaStartSt: qaContent?.qaStartSt,
    qaKindClsCd: qaContent?.qaKindClsCd ? qaContent?.qaKindClsCd : '0',
    qaWayClsCd: qaContent?.qaWayClsCd,
    qaTitle: qaContent?.qaTitle,
    qPersonCd: qaContent?.qPersonCd,
    qaContents: qaContent?.qaContents ? qaContent?.qaContents : '',
    qaTotalTime: qaContent?.qaTotalTime,
    qaStatusClsCd: qabasicEdit ? qaContent?.qaStatusClsCd : '1',
    qaCloseSt: qaContent?.qaCloseSt,
    answerDate: answerDate,
    relatedQaNo: qaContent?.relatedQaNo,
    keiyakuNo: qaContent?.keiyakuNo,
    custmNo: qaContent?.custmNo,
    attachedFile: qaContent?.attachedFile ? qaContent.attachedFile : '',
    attachedFileData: '',
    faqFlgClsCd: qaContent?.faqFlgClsCd,
    outKeiyakuCustmNm: qaContent?.outKeiyakuCustmNm,
    outKeiyakuPersonNm: qaContent?.outKeiyakuPersonNm,
    qaSeCd: qaContent?.qaSeCd,
    createDate: qaContent?.createDate,
    createCd: qaContent?.createCd,
    updateDate: qaContent?.updateDate,
    updateCd: qaContent?.updateCd,
    custmDepNo: qaContent?.custmDepNo,
    outKeiyakuTel: qaContent?.outKeiyakuTel,
    incidentUse: qaContent?.incidentUse,
    incidentAddCount: qaContent?.incidentAddCount,
    incidentAddFlg: qaContent?.incidentAddFlg,
    ssVersionClsCd: qaEnv?.ssVersionClsCd,
    serverOsClsCd: qaEnv?.serverOsClsCd,
    serverDbClsCd: qaEnv?.serverDbClsCd,
    serverConnectClsCd: qaEnv?.serverConnectClsCd,
    serverAsClsCd: qaEnv?.serverAsClsCd,
    clientOsClsCd: qaEnv?.clientOsClsCd,
    clientDbClsCd: qaEnv?.clientDbClsCd,
  })
  //categorySort(降順)
  const sortDesc = (list: typeCategory[]) => {
    list.sort((a, b) => {
      if (a.categoryCd < b.categoryCd) {
        return 1;
      } else {
        return -1;
      }
    })
    return list
  }

  //文字数カット
  const MAX_LENGTH_Title = 200
  const formatString = (str: string, name: string) => {
    if (name === 'qaTitle') {
      if (str.length > MAX_LENGTH_Title) {
        return str.substr(0, MAX_LENGTH_Title)
      } else {
        return str
      }
    } else {
      return str
    }
  }

  const handleChangeForm = (event: React.ChangeEvent<{ value: unknown; name?: string | undefined }>) => {
    setBasicForm({
      ...basicForm,
      [event.target.name as string]: formatString(event.target.value as string, event.target.name as string)
    })
  }

  const handleChangeUserCd = (memberObj: typeMemberList) => {
    setBasicForm({
      ...basicForm,
      "qPersonCd": memberObj.userCd,
      "custmDepNo": memberObj.departmentCd
    })
  };

  const handleChangeSeCd = (seObj: { userCd: string; userName: string; }) => {
    setBasicForm({
      ...basicForm,
      "qaSeCd": seObj.userCd
    })
  }

  const handleClickMenu = (event: React.ChangeEvent<{ id?: string | undefined }>) => {
    setKeiyakuClsCd(event.target.id ? event.target.id : '');
  }

  const _onInitialized = (sender: any) => {
    sender.calendar.formatItem.addHandler((sender: any, e: any) => {
      let weekday = e.data.getDay();
      wijmo.toggleClass(e.item, "date-sunday", weekday === 0);
      wijmo.toggleClass(e.item, "date-saturday", weekday === 6);
    })
  }

  const _onValueChanged = (sender: { value: Date }) => {
    setAnswerDate(sender.value)
  }

  const fileRemoveButton = () => {
    setBasicForm({
      ...basicForm,
      "attachedFile": '',
    })
  }

  const handleRemoveFile = () => {
    setNewfile({
      ...newfile,
      "attachedFile": '',
      "attachedFileData": ''
    })
    return ''//表示msgなし
  }

  const handleChangeFile = async (files: File[]) => {
    if (files[0]) {
      //base64Encode
      const base64Encode = (...parts: any) => {
        return new Promise(resolve => {
          const reader = new FileReader();
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              const offset = reader!.result!.indexOf(",") + 1;
              resolve(reader!.result!.slice(offset));
            }
          };
          reader.readAsDataURL(new Blob(parts));
        });
      }
      let file = files[0]
      const encodedFile = await base64Encode(file)
      setNewfile({
        ...newfile,
        "attachedFile": file.name,
        "attachedFileData": encodedFile as string
      })
    }
  }

  const handleSetLoginUserCd = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLoginUser(event.target.checked)
  }
  const fileDownload = (filepath: string) => {
    setFileloading(true);
    const base64DecodeAsBlob = async (text: string, type: string) => {
      const response = await fetch(`data:${type};base64,` + text);
      return await response.blob();
    }
    const base64Decode = async (text: string, type: string) => {
      const dataURI = `data:${type};base64,` + text
      var byteString = atob(dataURI.split(",")[1]);
      for (var i = 0, l = byteString.length, content = new Uint8Array(l); l > i; i++) {
        content[i] = byteString.charCodeAt(i);
      }
      return new Blob([content], { type: type })
    }
    (async () => {
      let mime_type = lookup(filepath) || 'application/octet-stream'
      const encodedFile = await getAttachedFile(userId, token, role, filepath).catch(err => { setFileloading(false); handleError(err) })
      if (encodedFile) {
        if (window.navigator.msSaveOrOpenBlob) {
          const decodedFile = await base64Decode(encodedFile, mime_type)
          window.navigator.msSaveOrOpenBlob(decodedFile, importpath.basename(filepath));
        } else {
          const decodedFile = await base64DecodeAsBlob(encodedFile, mime_type as string)
          let link = document.createElement('a');
          link.href = URL.createObjectURL(decodedFile)
          link.download = importpath.basename(filepath)
          link.click()
        }
      }
      setFileloading(false)
    })()
  }


  const onSubmit = () => {
    setLoading(true)
    const sendform = Object.assign({}, basicForm)
    if (answerDate) {
      sendform["answerDate"] = answerDate
    }
    if (newfile.attachedFile && newfile.attachedFileData) {
      sendform['attachedFile'] = newfile.attachedFile
      sendform['attachedFileData'] = newfile.attachedFileData
    }
    if (loginUser) {
      sendform["qaSeCd"] = basicForm["updateCd"] as string
    }
    putQaContent(userId, token, role, sendform).then(res => {
      setLoading(false)
      handleNotificationOpen('success', 'Q&A基本情報変更')
      handleAddSubmitCount()//QAContent更新
      handleCloseBasicEdit()//基本情報変更close
    }).catch(err => {
      setLoading(false);
      handleError(err)
    })
  }
  //必須項目チェックオブジェクト
  useEffect(() => {
    setReqItem({
      qPersonCd: basicForm!.qPersonCd ? false : true,
      qaTitle: basicForm!.qaTitle ? false : true,
      qaSeCd: basicForm!.qaSeCd ? false : true,
      custmNo: basicForm!.custmNo ? false : true,
      keiyakuNo: basicForm!.keiyakuNo ? false : true,
    })
  }, [basicForm])

  //初期表示APIコール
  useEffect(() => {
    if (basicForm.custmDepNo) {
      let cleanup = false
      getMemberList(basicForm.custmDepNo, userId, token, role).then(res => {//顧客メンバー取得
        if (!cleanup) { setMemberList(res); }
      })
      //ユーザー情報取得
      getUserInfo(userId, userId, token, role).then(res => {
        if (!cleanup) {
          setBasicForm({
            ...basicForm,
            updateCd: res.userCd
          })
        }
      }).catch(err => handleError(err))
      //CIS社員情報
      getCisUserList(userId, token, role, '').then(res => {
        if (!cleanup) { setCisUserList(res) }
      }).catch(err => handleError(err))
      //契約項目取得
      getContractItemList(basicForm.custmDepNo, userId, token, role).then(res => {
        if (!cleanup) {
          setContractItemList(res)
          if (res) {
            const val = res.filter(value => value.keiyakuNo === qaContent?.keiyakuNo)
            if (val && val.length === 1) {
              setSelectKeiyaku(val[0])
            }
          }
        }
      }).catch(err => handleError(err))
      //問合わせ方法
      getCategory('questionway', userId, token, role).then(res => {
        if (!cleanup) {
          setQuestionway(res.filter(value => value.categoryName !== 'Fax'))
        }
      }).catch(err => handleError(err))
      //QA対応状況
      getCategory('qastatus', userId, token, role).then(res => {
        if (!cleanup) {
          if (qaContent?.qaStatusClsCd === '0') {
            setQastatus(res.filter(value => value.categoryName === '未受付' || value.categoryName === '受付済' || value.categoryName === 'ドラフト'))
          } else if (qaContent?.qaStatusClsCd === '1' || qaContent?.qaStatusClsCd === 'd') {
            setQastatus(res.filter(value => value.categoryName === '受付済' || value.categoryName === 'ドラフト'))
          } else {
            setQastatus([])
          }
        }
      }).catch(err => handleError(err))
      //SuperStreamバージョン
      getCategory('ss_version', userId, token, role).then(res => { if (!cleanup) setSs_version(sortDesc(res)) }).catch(err => handleError(err))
      //サーバー環境（OS）
      getCategory('ss_serverOS', userId, token, role).then(res => { if (!cleanup) { setSs_serverOS(sortDesc(res)) } }).catch(err => handleError(err))
      //サーバー環境（DB）
      getCategory('ss_serverDB', userId, token, role).then(res => { if (!cleanup) { setSs_serverDB(sortDesc(res)) } }).catch(err => handleError(err))
      //サーバー環境（接続）
      getCategory('ss_serverConnect', userId, token, role).then(res => { if (!cleanup) { setSs_serverConnect(sortDesc(res)) } }).catch(err => handleError(err))
      //アプリケーションサーバー
      getCategory('ss_applicationserver', userId, token, role).then(res => { if (!cleanup) { setSs_applicationserver(sortDesc(res)) } }).catch(err => handleError(err))
      //クライアント環境（OS）
      getCategory('ss_clientOS', userId, token, role).then(res => { if (!cleanup) { setSs_clientOS(sortDesc(res)) } }).catch(err => handleError(err))
      //クライアント環境（DB）
      getCategory('ss_clientDB', userId, token, role).then(res => { if (!cleanup) { setSs_clientDB(sortDesc(res)) } }).catch(err => handleError(err))
      return () => { cleanup = true }
    }
  }, [basicForm.custmDepNo])
  if (qabasicEdit) {
    return (
      <React.Fragment>
        <Paper elevation={0} className={classes.root}>
          <Typography variant="subtitle1" style={{ flexGrow: 1 }}>
            基本情報編集
      </Typography>
          <Grid container spacing={1} justify="center" >
            <Grid item xs={12}>
              <QABasicEditForm basicForm={basicForm} newfile={newfile} fileloading={fileloading} keiyakuClsCd={keiyakuClsCd} cisUserList={cisUserList} loading={loading} loginUser={loginUser} userInfo={userInfo} reqItem={reqItem} answerDate={answerDate} userInfoList={userInfoList} memberList={memberList} contractItemList={contractItemList} questionway={questionway} ss_version={ss_version} ss_serverOS={ss_serverOS} ss_serverDB={ss_serverDB} ss_serverConnect={ss_serverConnect} ss_applicationserver={ss_applicationserver} ss_clientOS={ss_clientOS} ss_clientDB={ss_clientDB} qastatus={qastatus} handleChangeSeCd={handleChangeSeCd} handleChangeUserCd={handleChangeUserCd} handleChangeForm={handleChangeForm} handleClickMenu={handleClickMenu} _onInitialized={_onInitialized} _onValueChanged={_onValueChanged} handleChangeFile={handleChangeFile} handleRemoveFile={handleRemoveFile} fileRemoveButton={fileRemoveButton} handleSetLoginUserCd={handleSetLoginUserCd} fileDownload={fileDownload} onSubmit={onSubmit} selectKeiyaku={selectKeiyaku} qaContent={qaContent}/>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    )
  } else {
    return <FormAreaBasicEdit cisUserList={cisUserList} loginUser={loginUser} reqItem={reqItem} basicForm={basicForm} handleChangeSeCd={handleChangeSeCd} handleSetLoginUserCd={handleSetLoginUserCd} contractItemList={contractItemList} handleChangeForm={handleChangeForm} handleClickMenu={handleClickMenu} loading={loading} onSubmit={onSubmit} />
  }

}

export default QABasicEdit
